import Prism from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-yaml';

// Prism must not mutate React-rendered DOM through its automatic highlightAll
Prism.manual = true;

export const highlight = (text: string, language: string): string => {
  const grammar = Prism.languages[language];
  if (grammar === undefined) {
    return Prism.util.encode(text) as string;
  }
  return Prism.highlight(text, grammar, language);
};
